var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lz-field"},[_c('label',{staticClass:"lz-field-label"},[_vm._v("Manager")]),_c('b-select',{staticClass:"form-control",attrs:{"options":_vm.managers},on:{"change":_vm.managerChanged},model:{value:(_vm.selectedManager),callback:function ($$v) {_vm.selectedManager=$$v},expression:"selectedManager"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }